export default {
  CALCULATE_IO: {
    url: '/e-time/eTime/calculate-io',
    method: 'POST',
    isPublic: false
  },
  MONTHLY_ALLOWANCE: {
    url: '/e-time/eTime/monthly-allowance',
    method: 'POST',
    isPublic: false
  },
  IO_RECORDS: {
    url: '/e-time/eTime/io-records',
    method: 'GET',
    isPublic: false
  },
  IMPORT_HISTORY: {
    url: '/e-time/eTime/import-history',
    method: 'GET',
    isPublic: false
  },
  IMPORT_HISTORY_DETAIL: {
    url: '/e-time/eTime/import-history',
    method: 'GET',
    isPublic: false
  },
  SFTP_COMPANY_CLAIM: {
    url: '/e-time/eTime/sftp-jobs/claim',
    method: 'GET',
    isPublic: false
  },
  SFTP_RELEASE_CLAIM: {
    url: '/e-time/eTime/sftp-jobs/release-claim',
    method: 'POST',
    isPublic: false
  },
  SFTP_JOBS: { url: '/e-time/eTime/sftp-jobs', method: 'GET', isPublic: false },
  SFTP_JOB_DETAIL: {
    url: '/e-time/eTime/sftp-jobs/detail',
    method: 'GET',
    isPublic: false
  },
  SFTP_JOB_RESUME: {
    url: '/e-time/eTime/sftp-jobs/resume',
    method: 'POST',
    isPublic: false
  },
  SFTP_JOB_SYNC: {
    url: '/e-time/eTime/sftp-jobs/sync',
    method: 'POST',
    isPublic: false
  },
  SFTP_JOB_UPLOAD: {
    url: '/e-time/eTime/sftp-jobs/upload',
    method: 'POST',
    isPublic: false,
    isMultipart: true,
    headers: { 'Content-Type': 'multipart/form-data' }
  },
  GET_APPROVE_ALL: {
    url: '/e-time/eTime/get-approve-all',
    method: 'POST',
    isPublic: false
  },
  GET_ACTION_ALL: {
    url: '/e-time/eTime/get-action-all',
    method: 'POST',
    isPublic: false
  },
  GET_SP_ALLOWANCE_OPTION: {
    url: '/e-time/setting/sp-allowance/option',
    method: 'GET',
    isPublic: false
  },
  POST_SP_ALLOWANCE: {
    url: '/e-time/special-allowance',
    method: 'POST',
    isPublic: false
  },
  POST_REQ_EDIT_TIME: {
    url: '/e-time/eTime/request-edit-time',
    method: 'POST',
    isPublic: false
  },

  POST_OT_REQ: {
    url: '/e-time/ot/request',
    method: 'POST',
    isPublic: false
  },

  PUT_OT_REQ: {
    url: '/e-time/ot/edit',
    method: 'PUT',
    isPublic: false
  },

  POST_OT_APPROVE: {
    url: '/e-time/ot/approve',
    method: 'POST',
    isPublic: false
  },
  POST_CANCEL_OT: {
    url: '/e-time/ot/cancel',
    method: 'POST',
    isPublic: false
  },
  POST_APPROVE: {
    url: '/e-time/approve',
    method: 'POST',
    isPublic: false
  },
  POST_EDIT_REQ_TIME: {
    url: '/e-time/eTime/edit-request-edit-time',
    method: 'POST',
    isPublic: false
  },
  PUT_EDIT_SP_ALLOWANCE: {
    url: '/e-time/special-allowance',
    method: 'PUT',
    isPublic: false
  },
  POST_CANCEL_SP_ALLOWANCE: {
    url: '/e-time/special-allowance/cancel',
    method: 'POST',
    isPublic: false
  },
  POST_CANCEL_REQ_TIME: {
    url: '/e-time/eTime/cancel',
    method: 'POST',
    isPublic: false
  },
  ETIME_CREATE_DELEGATES: {
    url: '/e-time/delegate',
    method: 'POST',
    isPublic: false
  },
  ETIME_GET_ALL_DELEGATES: {
    url: '/e-time/delegate/',
    isPublic: false
  },
  ETIME_DELETE_DELEGATES: {
    url: '/e-time/delegate/',
    method: 'DELETE',
    isPublic: false
  },
  ETIME_EDIT_UPDATE_DELEGATES: {
    url: '/e-time/delegate/',
    method: 'PUT',
    isPublic: false
  },
  ETIME_GET_SP_ALLOWANCE_SETTING: {
    url: '/e-time/setting/sp-allowance',
    method: 'GET',
    isPublic: false
  },
  ETIME_PUT_SP_ALLOWANCE_SETTING: {
    url: '/e-time/setting/sp-allowance',
    method: 'PUT',
    isPublic: false
  },
  ETIME_GET_SETTING: {
    url: '/e-time/setting/main-setting',
    method: 'GET',
    isPublic: false
  },
  ETIME_PUT_SETTING: {
    url: '/e-time/setting/main-setting',
    method: 'PUT',
    isPublic: false
  },
  ETIME_POST_SETTING: {
    url: '/e-time/setting/main-setting',
    method: 'POST',
    isPublic: false
  },
  ETIME_DELETE_SP_ALLOWANCE_SETTING: {
    url: '/e-time/setting/sp-allowance',
    method: 'DELETE',
    isPublic: false
  },
  ETIME_GET_COSTCENTER_DATA: {
    url: '/e-time/pis-data/cost-center',
    method: 'GET',
    isPublic: false
  },
  ETIME_POST_SP_ALLOWANCE_SETTING: {
    url: '/e-time/setting/sp-allowance',
    method: 'POST',
    isPublic: false
  },
  ETIME_IMPORT_TIME: {
    url: '/e-time/eTime/import',
    method: 'POST',
    isPublic: false,
    isMultipart: true,
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  },
  ETIME_IMPORT_MAPPING_CARD: {
    url: '/e-time/mappingEmpCard/import',
    method: 'POST',
    isPublic: false,
    isMultipart: true,
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  },
  ETIME_IMPORT_SP_ALLOWANCE: {
    url: '/e-time/special-allowance/import',
    method: 'POST',
    isPublic: false,
    isMultipart: true,
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  },
  ETIME_IMPORT_OT: {
    url: '/e-time/ot/import',
    method: 'POST',
    isPublic: false,
    isMultipart: true,
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  },
  ETIME_GET_HR_SETTING: {
    url: '/e-time/setting/hr-setting',
    method: 'GET',
    isPublic: false
  },
  ETIME_SYNC_SFTP: {
    url: '/e-time/eTime/sync-sftp',
    method: 'GET',
    isPublic: false
  },
  ETIME_IMPORT_SFTP: {
    url: '/e-time/eTime/import-sftp',
    method: 'POST',
    isPublic: false,
    isMultipart: true,
    headers: { 'Content-Type': 'multipart/form-data' }
  },
  PERIOD_GET_LIST: {
    url: '/e-time/pay-period/get-list-period',
    method: 'GET',
    isPublic: false
  },
  PERIOD_CREATE: {
    url: '/e-time/pay-period/request-create-period',
    method: 'POST',
    isPublic: false
  },
  PERIOD_UPDATE: {
    url: '/e-time/pay-period/request-update-period',
    method: 'POST',
    isPublic: false
  },
  PERIOD_DELETE: {
    url: '/e-time/pay-period/request-delete-period',
    method: 'POST',
    isPublic: false
  },
  DOWNLOAD_TIME: {
    url: '/e-time/export/download',
    method: 'GET',
    isPublic: false,
    isBlob: true
  },
  COMPLETE_TIME_EXPORT_DOWNLOAD: {
    url: '/e-time/export/download-complete',
    method: 'POST',
    isPublic: false
  },
  GET_FILE: {
    url: '/e-time/export/get-list',
    method: 'GET',
    isPublic: false
  },
  EXPORT_FILE: {
    url: '/e-time/export',
    method: 'POST',
    isPublic: false
  },
  GET_EXPORT_STATUS: {
    url: '/e-time/export/status',
    method: 'GET',
    isPublic: false
  },
  GET_IMPORT_FILE_RESULT: {
    url: '/e-time/eTime/import-result',
    method: 'GET',
    isPublic: false
  },
  GET_TIME_EXPORT_OPTION: {
    url: '/e-time/export/options',
    method: 'GET',
    isPublic: false
  },
  GET_INFORMATION: {
    url: '/e-time/information/time-req/approver',
    method: 'GET',
    isPublic: false
  }
}
